// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!./font.css");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tsum body{--ui-font-family: "Geometria", system-ui, sans-serif;--ui-primary-color: #F94F0D}.tsum .font-accent{font-family:"Lenta",system-ui,sans-serif}`, "",{"version":3,"sources":["webpack://./src/app/css/design/tsum/index.css"],"names":[],"mappings":"AAEA,WACE,oDAAA,CACA,2BAAA,CAOF,mBACE,wCAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tsum": `tsum`,
	"fontAccent": `font-accent`
};
module.exports = ___CSS_LOADER_EXPORT___;
